import { render, staticRenderFns } from "./search-list.vue?vue&type=template&id=1435f5b6&scoped=true&"
import script from "./search-list.vue?vue&type=script&lang=js&"
export * from "./search-list.vue?vue&type=script&lang=js&"
import style0 from "./search-list.vue?vue&type=style&index=0&id=1435f5b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1435f5b6",
  null
  
)

export default component.exports